<template>
    <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%">
        <el-table-column
                fixed
                type="index"
                label="序号"
                :index="indexMethod"
                width="100">
        </el-table-column>
        <el-table-column
                fixed
                prop="name"
                label="采集商名称"
                width="200">
        </el-table-column>
        <el-table-column
                prop="category"
                label="采集品类"
                width="280">
        </el-table-column>
        <el-table-column
                prop="address"
                label="联系地址"
                width="280">
        </el-table-column>
        <el-table-column
                prop="organizationType"
                label="机构类型"
                width="180">
            <template slot-scope="prop">
                <span v-if="prop.row.organizationType == '1'">国有企业</span>
                <span v-if="prop.row.organizationType == '2'">集体所有制企业</span>
                <span v-if="prop.row.organizationType == '3'">股份制企业</span>
                <span v-if="prop.row.organizationType == '4'">联营企业</span>
                <span v-if="prop.row.organizationType == '5'">个人独资企业</span>
            </template>
        </el-table-column>
        <el-table-column
                label="操作"
                width="150">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="view(scope.row.id)">查看详情</el-button>
                <el-button type="text" size="small" @click="update(scope.row.id)">修改</el-button>
                <el-button type="text" size="small" @click="del(scope.row.id)">
                    <p class="red">删除</p>
                </el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    export default {
        name: "CollectorTable",
        props: {
            tableData: Array
        },
        data() {
            return {
            }
        },
        methods: {
            indexMethod(index) {
                return index+1;
            },
            view(id){
                this.$emit("view",id)
            },
            update(id){
                this.$emit("update",id)
            },
            del(id){
                this.$emit("del",id)
            }
        },
    }
</script>

<style scoped>
    .red{
        color: red;
    }
</style>
